import request from '@/util/request';
import qs from 'qs';

// 分页
export const monitorvideoPage = (params, options) =>
  request.get(
    '/api/v4ward/callcenter/monitorvideo/page',
    Object.assign({}, options, { params })
  );

// 新增
export const monitorvideosubmit = (params, options) =>
  request.post('/api/v4ward/callcenter/monitorvideo/submit', params, options, {
    ContentType: 'application/json',
  });


  // 新增
export const monitorvideoupdate = (params, options) =>
request.post('/api/v4ward/callcenter/monitorvideo/update', params, options, {
  ContentType: 'application/json',
});

export const monitorvideofavorite = (params, options) =>
request.post('/api/v4ward/callcenter/monitorvideo/favorite', params, options, {
  ContentType: 'application/json',
});


export const monitorvideoremove = (params, options) =>
request.post('/api/v4ward/callcenter/monitorvideo/remove', params, options, {
  ContentType: 'application/json',
});

export const videoareatree = (params, options) =>
request.get('/api/v4ward/callcenter/monitorvideo/video/area/tree', Object.assign({}, options, { params }));

export const monitorvideoareapage = (params, options) =>
request.get('/api/v4ward/callcenter/monitorvideo/video/area/page', Object.assign({}, options, { params }));
export const monitorvideofavoritepage = (params, options) =>
request.get('/api/v4ward/callcenter/monitorvideofavorite/page', Object.assign({}, options, { params }));

export const getAreaTreeApi = (params, options) =>
  request.get('/api/device/getAreaTree', Object.assign({}, options, { params }));

  export const getProjectList = (params, options) =>
  request.get('/api/v4ward/project/getProjectList', Object.assign({}, options, { params }));

  
  export const favorite = (params, options) =>
  request.get('/api/v4ward/callcenter/monitorvideo/favorite/page', Object.assign({}, options, { params }));

  export const favoritelist = (params, options) =>
  request.get('/api/v4ward/callcenter/monitorvideo/favorite/list', Object.assign({}, options, { params }));